export const DURATION_UNLIMITED = 1000
export const DURATION_NONE = 0